module.exports = __webpack_public_path__ + "img/rascrut-8.6d810ad7.webp";